module.exports = __webpack_public_path__ + "img/ProBit.90a91945.png";